// extracted by mini-css-extract-plugin
export var offer = "style-module--offer--6ac9a";
export var offer__block = "style-module--offer__block--a1d55";
export var offer__item = "style-module--offer__item--f6a60";
export var offer__list1 = "style-module--offer__list-1--f402b";
export var offer__list2 = "style-module--offer__list-2--5d5a8";
export var offer__subtitle = "style-module--offer__subtitle--00817";
export var offer__wrapper = "style-module--offer__wrapper--32fb8";